<script lang="ts">
	import { DropdownMenu as DropdownMenuPrimitive } from "bits-ui";
	import { cn } from "$lib/utils.js";

	let {
		ref = $bindable(null),
		class: className,
		variant = "default",
		...restProps
	}: DropdownMenuPrimitive.ItemProps & {
		variant?: "default" | "destructive";
	} = $props();
</script>

<!-- Open WebUI menu item: h-[1.6875rem] rounded-xl px-2 gap-2, 14px icons,
     translucent hover tint. -->
<DropdownMenuPrimitive.Item
	bind:ref
	data-slot="dropdown-menu-item"
	data-variant={variant}
	class={cn(
		"flex h-[1.6875rem] w-full cursor-pointer select-none items-center gap-2 rounded-xl px-2 text-[0.8125rem] font-normal outline-hidden transition-colors duration-100 data-highlighted:bg-gray-50/60 dark:data-highlighted:bg-gray-800/60 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:size-3.5 [&_svg]:shrink-0",
		variant === "destructive" ? "text-red-600 dark:text-red-400" : "",
		className
	)}
	{...restProps}
/>
